import { z } from 'zod';

export const ResolveMeetingJobSchema = z.object({
  meetingUrl: z.string().url(),
});

export type ResolveMeetingJob = z.infer<typeof ResolveMeetingJobSchema>;

export type ResolveMeetingResult = {
  threadId: string;
  tenantId: string;
  organizerId?: string;
  subject?: string;
};
